import React, { useEffect, useState } from "react";
import { request } from "../../../utils/request";
import { formatCurrency } from "../../../utils/helpers";
import Loader from "../../general/Loader";

const TarjetaCxP = ({anio, mes, vendedor, styles}) => {
    const tarjeta = "cxp";
    const [data, setData] = useState({})
    const [loading, setLoading] = useState(true)

    const getData = async (anio,mes) => {
        setLoading(true);
        const req = await request(`dashboard/gi?tarjeta=${tarjeta}&mes=${mes}&anio=${anio}&vendedor=${vendedor ? 1 : 0}`);

        if (req.success) {
            setData(req.data);
            setLoading(false);
        }
    };

    useEffect(() => {
      getData(anio,mes);
    }, [anio, mes]);

    if (loading === true) {
        return <div style={styles.columnStyles}>
            <Loader />
        </div>;
    }

    return (
        <div style={styles.columnStyles}>
            <div style={styles.columnContainer}>
                <div style={styles.header}>
                    <div className="color-primary" style={styles.principal}>
                        {formatCurrency(data.total)}
                    </div>
                    <div style={styles.subtitulo}>
                        Cuentas por Pagar
                    </div>
                </div>

                <div className="row">
                    <div style={styles.infoBlock}>
                        <div>
                            <strong><small className="badge badge-success">{data?.countVigentes}</small> {formatCurrency(data.totalVigentes)}</strong>
                        </div>
                        <small style={styles.label}>Vigentes</small>
                    </div>
                    <div style={styles.infoBlock}>
                        <div>
                            <strong><small className="badge badge-success">{data?.countVencidas}</small> {formatCurrency(data.totalVencidas)}</strong>
                        </div>
                        <small style={styles.label}>Vencidas</small>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TarjetaCxP;
